import { render, staticRenderFns } from "./LogoUploader.vue?vue&type=template&id=4970e2d0"
import script from "./LogoUploader.vue?vue&type=script&lang=ts"
export * from "./LogoUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports